import React from 'react'
import { Route, Switch } from 'react-router-dom'
import formsReducer from './reducers'
import { baseUrl } from '../../config/endpoints'
import { asyncComponent } from 'tr-components/AsyncComponent'

const AsyncCreate = asyncComponent(() => import('./containers/Create/CreateForm'))
const AsyncList = asyncComponent(() => import('./containers/List/List'))
const AsyncAddAssignments = asyncComponent(() => import('./containers/AddAssignments'))
const AsyncMassAssignments = asyncComponent(() =>
  import('./containers/MassAssignments/MassAssignments')
)
const AsyncAssignmentsList = asyncComponent(() => import('./containers/Assignments/List'))

export default Object.freeze({
  name: 'Forms',
  permission: 'FORMS_ALL',
  getNavLink: (clientId) => undefined,
  reducers: {
    Forms: formsReducer
  },
  getRoutes: (basePath) => (
    <Route
      key="forms"
      path={`${basePath}/forms`}
      render={({ location, match }) => {
        return (
          <Switch>
            <Route component={AsyncList} exact path={match.path} />
            <Route component={AsyncCreate} exact path={`${match.path}/create`} />

            <Route
              path={`${match.path}/:formId`}
              render={({ location, match: submatch }) => {
                return (
                  <Switch>
                    <Route component={AsyncCreate} exact path={`${submatch.path}/edit`} />
                    <Route
                      component={AsyncAssignmentsList}
                      exact
                      path={`${submatch.path}/assignments`}
                    />
                    <Route
                      component={AsyncAddAssignments}
                      exact
                      strict
                      path={`${submatch.path}/assignments/add`}
                    />
                    <Route
                      component={AsyncMassAssignments}
                      exact
                      strict
                      path={`${submatch.path}/mass-assignments`}
                    />
                  </Switch>
                )
              }}
            />
          </Switch>
        )
      }}
    />
  )
})

export const listUrl = (clientId) => `${baseUrl}/clients/${clientId}/forms`

// export default ({ childProps }) => (

// )
//
// export { default as formsReducer } from './reducers'



// WEBPACK FOOTER //
// ./src/modules/Forms/index.js